import React, {Dispatch} from "react";
import './stapeForm.css'
import { FiCheck } from "react-icons/fi";
interface StapeFormProps {
    name:string,
    index:number,
    complete:boolean,
    currentStape:number,
    setNewCurrentStape:(id:number) => void
}

const StapeForm:React.FC<StapeFormProps> = ({name,index,complete,currentStape,setNewCurrentStape}) => {

    const handleClick = () => {
        if(currentStape > index) {
            setNewCurrentStape(index)
        }
    }

    return (
        <div className={`stapeForm ${currentStape < index && 'locked'} ${complete && 'complete'}`} onClick={handleClick}>
            <div className="isComplete">
                {
                    complete ? 
                        <FiCheck size={25} />
                        :
                        <p className="smallTitle">{index+1}</p>
                }
            </div>
            <p className={`name ${currentStape === index ? 'smallTitleBold' : 'smallTitle'}`}>{name}</p>
            {currentStape === index && <div className="line"></div>}
        </div>
    )
} 
export default StapeForm